import React from 'react';

import { Circle } from '@shared/assets';

import { Scroller } from '../session-scroller';
import { addressToString } from './lib';
import * as st from './styles.module.scss';

type Props = {
	sessions: any[];
	onClick: (id: number) => void;
};

export const OfflineSessions: React.FC<Props> = ({ sessions, onClick }) => {
	function sortNoAddress(sessions: any[]) {
		// сохраняем отдельно сессии без адреса

		if (!sessions) {
			return;
		}

		const allSessions = [...sessions];
		const noAddressSessions = [];

		for (const session of allSessions) {
			if (session.address && session.address.length === 0) {
				noAddressSessions.push(session);
			}
		}

		return noAddressSessions;
	}

	function sortByAddress(sessions: any[]) {
		/**
		 * сортируем сессии по адресам, преобразовывая массив
		 * сессий из [{сессия с адресом 1}, {сессия с адресом 2}] в
		 * [
		 *  {
		 *    address: адрес 1,
		 *    sessions:  [{ceccия с адресом 1}]
		 *  },
		 *  {
		 *    address: адрес 2,
		 *    sessions:  [{ceccия с адресом 2}]
		 *  }
		 * ]
		 */
		if (!sessions) {
			return;
		}

		const allSessions = [...sessions];

		const uniqAddress = allSessions
			.filter(
				(session, index, array) =>
					// находим сессии с уникальными адресами
					array.findIndex(
						(s) =>
							s.address.length > 0 &&
							session.address.length > 0 &&
							s.address[0].id === session.address[0].id
					) === index
			)
			.map((session) => ({
				// преобразовываем каждую сессию в объект с пустым массивом сессий
				address: session.address[0],
				sessions: [],
			}))
			.map((address) => {
				// заполняем каждый пустой массив сессиями с подходящими адресами
				let newAddress: { address: any; sessions: any[] } = { ...address, sessions: [] };
				/* eslint-disable-next-line */
				let matchAddress = allSessions.filter((session) => {
					if (session.address.length > 0) {
						return session.address[0].id === newAddress.address.id;
					}
				});

				newAddress = { ...newAddress, sessions: [...matchAddress] };
				return newAddress;
			});

		return uniqAddress;
	}

	const noAddress = sortNoAddress(sessions);
	const hasAddress = sortByAddress(sessions);

	return (
		<div className={st.offline}>
			{noAddress && noAddress.length > 0 && (
				<div className={st.title}>
					<div className={st.icon}>
						<Circle />
					</div>
					<span>Без адреса</span>
				</div>
			)}
			{noAddress && noAddress.length > 0 && (
				<Scroller sessions={noAddress} onClick={onClick} quantity={10} />
			)}
			{hasAddress &&
				hasAddress.length > 0 &&
				hasAddress.map((address) => (
					<React.Fragment key={addressToString(address.address)}>
						<div className={st.title}>
							<div className={st.icon}>
								<Circle />
							</div>
							<span>{addressToString(address.address)}</span>
						</div>
						<Scroller sessions={address.sessions} onClick={onClick} quantity={14} />
					</React.Fragment>
				))}
		</div>
	);
};
